import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
  getValidate,
} from "./schema.kycVerification.1";
import { IExtraData } from "./schema.kycVerification.types";
import { getInitialValues } from "./schema.kycVerification.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
      validate: getValidate(extraData),
    },
  ];
};
